import SuperFetch from '../../superFetch.js';

class SearchWordApi {
  /**
   *  [검색 키워드 리스트] 리스트 요청하기
   */
  getSearchWordList = (data) => SuperFetch.post('/searchWord/list', data);

  /**
   *  [검색 키워드 리스트] 엑셀 다운로드
   */
  getSearchWordListExcelDownload = (data) => SuperFetch.post('/searchWord/list/excel/download', data);

  /**
   *  검색 키워드 편집하기 전 필요한 데이터 가져오기
   */
  getSearchWordDetail = (data) => SuperFetch.post('/searchWord/detail', data);

  /**
   *  키워드 체크하기
   */
  checkKeyword = (data) => SuperFetch.post('/searchWord/check/word', data);

  /**
   *  검색 키워드 등록하기
   */
  createSearchWord = (data) => SuperFetch.post('/searchWord/insert', data);

  /**
   *  검색 키워드 편집하기
   */
  editSearchWord = (data) => SuperFetch.post('/searchWord/edit', data);

  /**
   *  검색 키워드 삭제 요청하기
   */
  deleteSearchWord = (data) => SuperFetch.post('/searchWord/delete', data);

  /**
   *  연관 키워드 리스트 요청하기
   */
  getRelatedSearchWordList = (data) => SuperFetch.post('/searchWord/insert/preparation/related/list', data);
}

export default new SearchWordApi();
